<!--Create Account Title-->
<h2>Create Account</h2>
<p>Customer ID: {{createCloudAccountRequest.customerId}}</p>
<form #createAccountForm="ngForm" novalidate>
    <mat-dialog-content>
        <!--Dialog Content-->
        <div *ngIf="!createCloudAccountResponse">
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Description</mat-label>
                    <input aria-required="true" required matInput [(ngModel)]="createCloudAccountRequest.description"
                        name="description" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Region</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="createCloudAccountRequest.region"
                        name="region">
                        <mat-option *ngFor="let item of createCloudAccountDialogData.regions" [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="createCloudAccountResponse">
            <label>Account Id: {{createCloudAccountResponse.accountId}}</label> <br />
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <!--Dialog action buttons-->
        <button mat-raised-button color="primary" (click)="save()"
            [disabled]="createAccountForm.form.invalid || isSaving" *ngIf="!createCloudAccountResponse">
            <span *ngIf="!isSaving">Save</span>
            <span *ngIf="isSaving">Saving...</span>
        </button>
        <button mat-raised-button [disabled]="isSaving" (click)="close()">Cancel</button>
    </mat-dialog-actions>
</form>